/*
 * Module for the MemberDirect communicationpreferences detail
*/

rs.module("content/user/profile/communicationpreferences",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, propertyAliases) {

            var communicationSettingRows = $.js(jsSelectors.communicationSettingsRow, { multiple: true });
            var communicationSettingToggles = $.js(jsSelectors.communicationSettingToggle, { multiple: true });

            // When any toggle is changed, queue up the backend request to update the communication preferences
            // It'll be debounced slightly to mitigate repetitive requests / notifications
            communicationSettingToggles.change(_.debounce(function () {

                // Get the data from all of the rows
                var updatedPreferences = [];
                communicationSettingRows.each(function () {

                    var preference = {};
                    preference[propertyAliases.eDeliveryEntity_BatchType] = $(this).js(jsSelectors.batchType).val();
                    preference[propertyAliases.eDeliveryEntity_DistributionPreferenceKey] = $(this).js(jsSelectors.distributionPreferenceKey).val();
                    preference[propertyAliases.eDeliveryEntity_EmailDeliveryFlag] = $(this).js(jsSelectors.communicationSettingToggle).is(':checked');

                    updatedPreferences.push(preference);
                })

                $.post(
                    backendUrls.SaveDistributionPreferences,
                    {
                        updatedPreferences: updatedPreferences,
                    }
                );

            }, 250));
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);